/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type ReviewStatistic } from '../../../interface/types';
import { SubmitReviewButton } from '@/features/reviews/components/SubmitReviewButton/SubmitReviewButton';
import { useReviewsOverviewProps } from '../hooks/useReviewsOverviewProps';
import { Text } from '@az/starc-ui';

type WriteReviewCTA = {
  reviewStatistic: ReviewStatistic;
  reviewCount: number;
  recommendedCount: number;
};

export const WriteReviewCTA = ({
  recommendedCount,
  reviewCount,
  reviewStatistic,
}: WriteReviewCTA) => {
  const { productId, productName, productImageUrl, myProfileEmail, myProfileFirstName, labels } =
    useReviewsOverviewProps({
      reviewStatistic,
      reviewCount: reviewCount.toString(),
      recommendedCount,
    });

  return (
    <SubmitReviewButton
      productId={productId}
      defaultValues={{
        useremail: myProfileEmail,
        usernickname: myProfileFirstName,
      }}
      pageType="ProductDetail"
      label={
        <Text variant="small-body" weight="bold">
          {labels.writeAReview}
        </Text>
      }
      variant="pill-secondary"
      productName={productName}
      productImageUrl={productImageUrl}
    />
  );
};
